
const state = {
    sInvoiceModalStatus: false
}
const getters = {
    getSInvoiceModalStatus: (state) => {
        return state.sInvoiceModalStatus
    }
}

const mutations = {
    updateSInvoiceModalStatus: (state, newValue) => {
        state.sInvoiceModalStatus = newValue
    }
}

const actions = {
    setSInvoiceModalStatus: ({ commit }, newValue) => {
        commit('updateSInvoiceModalStatus', newValue)
    }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/sInvoice.js